<template>
    <div>
        <eqt-table
            :icon="icon"
            :color="color"
            :header-color="headerColor"
            :hide-search="hideSearch"
            :hide-pagination="hidePagination"
            :hide-show-btn="hideShowBtn"
            :hide-edit-btn="hideEditBtn"
            :hide-actions="hideActions"
            @refresh="refresh"
            @delete="deleteItem"
            :total="total"
            :loading="loading"
            :title="computedTitle"
            :subtitle="computedSubtitle"
            :items="items"
            :headers="computedHeaders">
                <template slot="filters">
                    <v-flex lg3 v-if="!hideUploadBtn">
                        <v-tooltip top>
                            <v-btn slot="activator" absolute right small fab dark color="indigo dark1" @click="dialogUpload = true">
                                <v-icon dark>mdi-upload</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.upload')}}</span>
                        </v-tooltip>
                    </v-flex>
                </template>
                <template slot="add">
                    <slot name="add"></slot>
                </template>
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.id }}</td>
                    <td class="text-xs-center">
                        <v-avatar slot="activator" size="30px">
                            <img :src="item.profile.avatar" :alt="item.profile.name">
                        </v-avatar>
                    </td>
                    <td>{{ item.profile.name }}</td>
                    <td>{{ item.email}}</td>
                    <td>{{ item.roles && item.roles.length > 0 ? item.roles.map(r => r.name).join(', ') : ''}}</td>
                    <td>{{ item.barcode}}</td>
                    <td>{{ getLocaleDateFormat(item.last_login)}}</td>
                    <td>{{ getLocaleDateFormat(item.profile.started_working)}}</td>
                    <td class="text-xs-center">{{ item.profile.is_agency ? $t('Common.yes') :  $t('Common.no')}}</td>
                    <td class="text-xs-center" v-if="travelWarrants">{{ item.pivot && item.pivot.note ? item.pivot.note : $t('Common.not_assigned') }}</td>
                    <slot name="items" :item="item"></slot>
                </template>
        </eqt-table>
        <upload-dialog  @close="onCloseDialog" :dialog="dialogUpload"></upload-dialog>
    </div>
</template>

<script>

    import UploadDialog from './UploadDialog'
    import EqtTable from '../../components/core/Table'
    import i18n from '@/i18n'
    export default {
        name: "users-table",
        components: {EqtTable, UploadDialog},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'tertiary'
            },
            headerColor: {
                type: String,
                default: 'text-primary text--darken-3'
            },
            title: {
                type: String,
                default: null,
            },
            subtitle: {
                type: String,
                default: null,
            },
            hideSubtitle: {
                type: Boolean,
                default: false
            },
            hidePagination: {
                type: Boolean,
                default: false
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            hideShowBtn: {
                type: Boolean,
                default: false
            },
            hideEditBtn: {
                type: Boolean,
                default: false
            },
            hideUploadBtn: {
                type: Boolean,
                default: false
            },
            sortable: {
                type: Boolean,
                default: true
            },
            appendHeaders: {
                type: Array,
                default: () => []
            },
            travelWarrants: {
              type: Boolean,
              default: false
            }
        },
        data() {
            let data = {
                dialogUpload: false,
                headers: [
                    {
                        sortable: this.sortable && true,
                        text: '#',
                        value: 'id'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Users.model.avatar'),
                        value: 'profile.avatar',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.name'),
                        value: 'profile.name'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.email'),
                        value: 'email'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.roles'),
                        value: 'roles'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.barcode'),
                        value: 'barcode'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.last_login'),
                        value: 'last_login'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Users.model.started_working'),
                        value: 'profile.started_working'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Users.model.agency'),
                        value: 'profile.is_agency',
                        align: 'center'
                    }
                ]
            };

            return data;
        },
        computed:{
            computedHeaders(){
                return this.headers.concat(this.appendHeaders);
            },
            computedTitle(){
                return this.title ? this.title : this.$t('Pages.Users.title');
            },

            computedSubtitle(){
                if(this.hideSubtitle){
                    return null;
                }
                return this.subtitle ? this.subtitle : this.$t('Common.table_subtitle');
            }
        },
        methods: {
            onCloseDialog(refresh){
                this.dialogUpload = false;
            },
            refresh(data){
                this.$emit('refresh', data);
            },
            deleteItem(item){
                this.$emit('delete', item);
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
